const { client, loadToken } = require('api/client');
export { loadToken };

export async function getAllData(query) {
    var { data } = await client.get(`/crowd_counting/allData`, {
        params: query
    });

    return data;
}

export async function getCameraLocation(uuid) {
    var { data } = await client.get(`/crowd_counting/location/${uuid}`);
    return data;
}

export async function updateCameraLocationData(data) {
    console.log(data);
    var { data } = await client.put(`/crowd_counting/location/${data.uuid}`, data);
    return data;
}

export async function getCameraEvents(event_id) {

    let url = `/crowd_counting/events`;

    if (typeof event_id != 'undefined') {
        url += '/' + event_id;
    }

    let { data } = await client.get(url);
    return data;
}

export async function getProcessedImage(id) {

    let url = `/crowd_counting/processed/${id}`;

    if (typeof event_id != 'undefined') {
        url += '/' + event_id;
    }

    let { data } = await client.get(url, {
        responseType: 'arraybuffer'
    });
    return data;
}

export async function latestRPiImage(uuid) {

    let url = `/crowd_counting/latestRPIImage/${uuid}`;


    let { data } = await client.get(url, {
        responseType: 'arraybuffer'
    });
    return data;
}

export async function closestRPiImage(uuid, timestamp) {

    let url = `/crowd_counting/closestRPIImage/${uuid}/${timestamp}`;


    let { data } = await client.get(url, {
        responseType: 'arraybuffer'
    });
    return data;
}

export async function uploadEventData(event) {

    let url = `/crowd_counting/events/`;


    let { data } = await client.post(url, event);
    return data;
}


const all = {
    loadToken, getAllData, getCameraLocation, updateCameraLocationData, getCameraEvents, getProcessedImage, uploadEventData
};

export default all;